<template>
  <Elcheckbox
    v-bind="$attrs"
    fill="#ED1517"
    class="f360-checkbox"
    v-model="value"
    :class="{ 'f360-checkbox--error': error }"
  />
</template>

<script setup lang="ts">
import Elcheckbox from "element-plus/es/components/checkbox/index";
import { computed } from "vue";

const props = defineProps<{
  error?: boolean;
  modelValue: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
});
</script>

<style lang="scss">
.f360-checkbox {
  &--error {
    .el-checkbox {
      &__wrapper {
        box-shadow: none;

        &:hover {
          background-color: #fff1f1;
        }
      }
    }
  }
}
</style>
